<template>
  <table class="table-a">
      <tr>
        <th>Faktura #</th>
        <th>Tekst</th>
        <th>Dato</th>
        <th>Status</th>
        <th class="align-r">Ex. moms</th>
        <th></th>
      </tr>
      <tr v-for="(invoice,i) in invoices">
        <td>{{invoice.invoice_no}}</td>
        <td><div class="textlink" @click="msg(invoice.title)">{{invoice.title | cut(25)}}</div></td>
        <td>{{invoice.date}}</td>
        <td>{{invoice.status}}</td>
        <td class="align-r">{{invoice.total_ex_vat_dkk | money(2)}} kr.</td>
        <td class="align-r">
          <span v-if="hasMatchingEconomyPost(invoice)">✓</span>
          <div class="textlink" v-else @click="copyInvoiceToEconomyPost(invoice)">Kopiér</div>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="align-r">Total</td>
        <td class="align-r"><b>{{total | money(2)}} kr.</b></td>
        <td></td>
      </tr>
    </table>
</template>

<script>
import mixins from '../mixins.js'
export default {
  props: [ 'invoices' ],
  mixins: [ mixins.db, mixins.generic ],
  computed: {

    total(){
      var total = 0
      for( let i of this.invoices ) total += i.total_ex_vat_dkk
      return total
    },

  },
  methods: {
    
    hasMatchingEconomyPost( invoice ){

      for( let post of this.getAll('economyposts') ) {
        //console.log(post,invoice)
        if( post.invoice_no != invoice.invoice_no ) continue
        if( post.amount_dkk_ex_vat != invoice.total_ex_vat_dkk ) continue
        if( post.invoice_date != invoice.date ) continue
        return true
      }

    },

    copyInvoiceToEconomyPost(invoice){
      alert('Denne feature er på vej, mvh William. Estimat er 1 times arbejde.')
    },

  },
}
</script>


// WEBPACK FOOTER //
// DineroInvoices.vue?2784d85d